import { format } from 'date-fns'
import sv from 'date-fns/locale/sv'

export default (date, _format = 'YYYY-MM-DD') =>
  format(date, _format, {
    locale: sv
  })
